import {
    Col,
    FormGroup,
    FormLabel,
    Row,
    Container
} from "react-bootstrap";
import logo from "./logo.png";
import { connect } from "react-redux";
import { mapStateToProps } from "./store/helpers/mapState";
import { mapDispatchToProps } from "./store/helpers/mapDispatch";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { default as ReactSelect } from "react-select";
import {
    Alert,
    Button,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    TextField,
    Typography,
    Modal,
    DialogTitle, DialogContent, DialogActions, Dialog, DialogContentText
} from "@mui/material";
import { AttachFile, Send } from "@mui/icons-material";
import { Controller, useForm } from "react-hook-form";
import { inArray } from "./store/User/action";
import CountrySelector from "./components/CountrySelector";

const renderError = (name, errors) => errors[name] &&
    <p role="alert" className={'text-danger'} style={{ fontSize: "12px" }}>{errors[name]?.message}</p>;

const RenderField = ({ name, label, sideLabel, type, placeholder, required, values, multiline, rows, register, errors, max, min, minLength, maxLength, control, disabled }) => {
    const rules = {
        required: required ? (typeof required === 'string' ? required : 'This field is required') : false,
        max: typeof max === 'number' ? { value: max, message: `Maximum number is ${max?.toLocaleString()}` } : undefined,
        min: typeof min === 'number' ? { value: min, message: `Minimum number is ${min?.toLocaleString()}` } : undefined,
        minLength: typeof minLength === 'number' ? { value: minLength, message: `Minimum length is ${minLength?.toLocaleString()}` } : undefined,
        maxLength: typeof maxLength === 'number' ? { value: maxLength, message: `Maximum length is ${maxLength?.toLocaleString()}` } : undefined,
        pattern: (type === 'tel' ? {
            value: /^(^\+?(?:[+0]9)?[0-9]{8,14}$)$/i,
            message: "Invalid Phone number"
        } : (type === 'email' ? {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Invalid email address"
        } : null))
    }
    // const registerFunc = control ? register(name, rules) : undefined;

    const border = errors[name] ? 'border-danger' : '';
    const errorClass2 = errors[name]
        ? "select-error text-capitalize"
        : "text-capitalize";
    const classN = `form-control  ${border} `;
    const newLabel = <Typography variant={'subtitle1'}>{label} {required ? <span className={'text-danger'}>*</span> : null}</Typography>;
    return <FormGroup className={'mb-3'} key={name}>
        <FormLabel className={'w-100'}>{sideLabel ? <div className={'d-flex'}>
            <div className={'flex-grow-1'}>{newLabel}</div>
            {sideLabel}
        </div> : newLabel}</FormLabel>
        {type === 'file' ? <input className={classN} type={'file'} {...register(name, rules)} /> : (type === 'react-select' || type === 'country' ? <Controller
            control={control}
            key={name}
            rules={rules}
            name={name}
            render={({ field, fieldState: { error } }) => {
                let selectedValue =
                    values?.find((item) => item.value === field.value) ?? null;
                return type === "country" ? (
                    <CountrySelector
                        // placeholder={v.placeholder ?? v.label}
                        className={errorClass2}
                        value={field.value}
                        onChange={(v) => field.onChange(v?.value)}
                    />
                ) : (
                    <ReactSelect
                        className={errorClass2}
                        value={!field.value ? null : selectedValue}
                        options={values}
                        onChange={(v) => field.onChange(v?.value)}
                    />
                )

            }}
        /> : (type === 'select' ? <select className={classN} {...register(name, rules)}>
            {values?.map(v => <option value={v.value}>{v.label}</option>)}
        </select> : <TextField
            sx={border ? {
                "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                        borderColor: "rgb(220,53,69)",
                    },
                },
            } : undefined}
            multiline={multiline} rows={rows} type={type} size={'small'} fullWidth={true} placeholder={placeholder ?? label}
            {...register(name, rules)} />))}
        {renderError(name, errors)}
    </FormGroup>;
}

function ApplicationForm({ FetchDetails, SubmitGeneralForm }) {
    const { register, handleSubmit, watch, formState: { errors }, setValue, clearErrors, control } = useForm();

    const [positions, setPositions] = useState([]);
    const [fields, setFields] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [modal, setModal] = useState(false);
    const [schoolsList,setSchools] = useState([]);
    const [schoolsList1,setSchools1] = useState([]);
    const [loading, setLoading] = useState(false);
    const [rwanda, setRwanda] = useState(true);
    const [addField, setAddField] = useState(false);
    const [nationality, setNationality] = useState();
    const [selectedPositions, setSelectedPositions] = useState([]);
    const [position, setPosition] = useState(null);
    const [addSchool, setAddSchool] = useState(false);

    // const ref = useRef();

    const toggle = () => setModal(!modal);


    useEffect(() => {
        watch((value, { name, type }) => {
            if (type === 'change') {
                if (name === 'nationality') {
                    setNationality(value[name]);
                    setRwanda(value[name] === 'Rwanda');
                    setValue('position', null);
                    setSelectedPositions([]);
                }

                if (name === 'position') {
                    setSelectedPositions(value[name]);
                }

                if (name === 'studyField') {
                    setAddField(value[name] === '-');
                }
                if (name === 'school') {
                    setAddSchool(value[name] === 'other');
                }

            }
        })
    }, [watch]);


    const loadPositions = async () => {
        const resp = await FetchDetails("position");
        if (resp.status) {
            setPositions(resp.data.data)
        }
    }
    const loadFields = async () => {
        const resp = await FetchDetails("fields");
        // const school = await FetchDetails("fields/school/list");
        // if(school){
        //     const initial=   [
        //         {
        //             value: "",
        //             label: "--select--"
        //         }]
        //     const schools = school.data.data?.map(v => ({ value: v.school, label: v.school })); 
        //     setSchools1(school.data.data)
        //     setSchools(
        //         initial.concat( [...schools,{
        //             value: "other",
        //             label: "Other"
        //         },])
        //      )
        // }
        if (resp.status) {
            const newFields = resp.data.data?.map(v => ({ value: v.id, label: v.name }));
            setFields([...newFields, {
                value: "-",
                label: "Other"
            }])
        }
    }

    const submitForm = async (data) => {
        setLoading(true);
        const resp = await SubmitGeneralForm("/apply", data);
        if (resp.status) {
            Swal.fire({
                title: "Success!",
                text: resp.data?.message ?? "Success !",
                icon: 'success'
            }).then(() => {
                window.location.href = "/";
            });
        } else {
            Swal.fire({
                title: "Error!",
                text: resp.data?.response?.data?.message ?? "Error !",
                icon: 'error'
            }).then();
        }
        setLoading(false);
    }

    useEffect(() => {
        loadPositions().then();
        loadFields().then();
    }, []);



    const filteredPositions = positions.filter(v => rwanda || v.international || !nationality);

    const onSubmit = (data) => {

        if (!documents.length) {
            Swal.fire({
                title: "Error!",
                text: "No Documents attached",
                icon: 'error'
            }).then();
            return;
        }
        // data = new FormData(data);

        if (!data.position?.length) {
            Swal.fire({
                title: "Error!",
                text: "At least one position has to be selected",
                icon: 'error'
            }).then();
            return;
        }

        if (data.position?.length > 2) {
            Swal.fire({
                title: "Error!",
                text: "Not allowed to select more than two position",
                icon: 'error'
            }).then();
            return;
        }


        const formData = new FormData();

        Object.keys(data).forEach(v => {
            let ob = data[v];
            if (typeof ob === 'object') {
                if (Array.isArray(ob)) {
                    ob.forEach(item => {
                        formData.append(v, item);
                    })
                } else {
                    formData.append(v, Array.from(ob)[0]);
                }
            } else {
                formData.append(v, ob);
            }
        });

        documents.forEach((item) => {
            formData.append("document", item.file);
            formData.append("documentName", item.name);
        });

        submitForm(formData).then();
    }

    const handleFieldClose = () => {
        setAddField(false);
        setValue('studyField', null);
    }
    const schools =[
        { label: "-- select --", value: "" },
        { label: "Carnegie Mellon University", value: "cmu" },
        { label: "University of Rwanda", value: "university of rwanda" },
        { label: "Rwanda Coding Academy", value: "rwanda coding academy" },
        { label: "African Leadership University", value: "african leadership university" },
        // { label: "Other", value: "other" },
    ]
    // const highSchool=[
    //     { label: "-- select --", value: "" },
    //     { label: "Rwanda Coding Academy", value: "rwanda coding academy" },
    //     { label: "Other", value: "other" },

    // ]
    return <>
        <Dialog open={position !== null} onClose={() => {

            if (position.array) {
                setValue('position', position.array);
                setSelectedPositions(position.array);
            }

            setPosition(null);



        }}>
            <DialogContent>
                <DialogContentText>
                    <div dangerouslySetInnerHTML={{ __html: position?.requirements }}></div>
                </DialogContentText>
            </DialogContent>
        </Dialog>
        <Dialog open={addField} onClose={handleFieldClose} maxWidth={'xs'} fullWidth={true}>
            <form onSubmit={(e) => {
                e.preventDefault();
                const data = new FormData(e.currentTarget);
                const value = data.get("field");
                setFields(fields => [...fields, {
                    value,
                    label: value
                }]);
                setAddField(false);
                setValue("studyField", value)
            }}>
                <DialogTitle>Add New Field of Study</DialogTitle>
                <DialogContent>
                    <TextField size={'small'} name={'field'} required={true} placeholder={'Enter new field of study'} fullWidth={true} />
                </DialogContent>

                <DialogActions>
                    <Button color="error" onClick={handleFieldClose}>
                        Cancel
                    </Button>{' '}
                    <Button type={'submit'} style={{ backgroundColor: "#054163" }} variant={'contained'}>
                        Add
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
        <Dialog open={modal} onClose={toggle}>
            <form onSubmit={(e) => {
                e.preventDefault();
                const data = new FormData(e.currentTarget);
                setDocuments(documents => [...documents, {
                    name: data.get("name"),
                    file: data.get("file")
                }])
                e.currentTarget.reset();
                toggle();
            }}>
                <DialogTitle toggle={toggle} className={'fw-bold'}>Document Details</DialogTitle>
                <DialogContent>
                    <FormGroup className={'mb-3'}>
                        <FormLabel className={'fw-bold'}>File Name</FormLabel>
                        <input className={'form-control'} name={'name'} required={true} placeholder={'Name'} />
                    </FormGroup>
                    <FormGroup className={'mb-3'}>
                        <FormLabel className={'fw-bold'}>Attach File</FormLabel>
                        <input type={'file'} accept={'image/*,application/pdf'} required={true} name={'file'} className={'form-control'} />
                    </FormGroup>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={toggle}>
                        Cancel
                    </Button>{' '}
                    <Button type={'submit'} style={{ backgroundColor: "#054163" }} variant={'contained'}>
                        Add File
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
        <form onSubmit={handleSubmit(onSubmit)}>
            <div>
                <div className={'text-center mb-3 mt-3'}>
                    <img src={logo} alt={'QT Software global ltd logo'} style={{ width: '200px' }} />
                </div>
            </div>
            <Container>
                <Row className={'justify-content-center mt-3 p-3'}>
                    {/*<Col lg={3} md={1}>*/}
                    {/*    <Card>*/}
                    {/*        <CardContent>*/}

                    {/*        </CardContent>*/}
                    {/*    </Card>*/}
                    {/*</Col>*/}
                    <Col lg={12} xl={10}>
                        {/*<input type="file" id={'input-file-picture'} accept={"image/*"} className={'hidden'} style={{display:"none"}} name={'profile'} ref={ref} onChange={(e)=>{*/}
                        {/*    const file = Array.from(e.currentTarget.files)[0];*/}
                        {/*    if(file.name) {*/}
                        {/*        setProfile(file);*/}
                        {/*    }*/}
                        {/*}}/>*/}
                        <Card className={'mb-5'} sx={{ backgroundColor: "#f8f8f8" }}>
                            <CardContent className={'card-body'}>
                                <Typography variant={'h3'} className={'mb-4 text-center'} style={{ fontWeight: 'bold' }}>Job Application Form</Typography>
                                {/* <div className={'text-center mb-4'}>*/}
                                {/*    <div onClick={()=>{*/}
                                {/*        ref.current.click();*/}
                                {/*    }} className={'profile-picture d-inline-flex align-items-center justify-content-center border rounded-pill'} style={{height:"150px",width:"150px",backgroundSize:'cover',backgroundImage:profile ? `url(${URL.createObjectURL(profile)})` : undefined}}>*/}
                                {/*        {!profile && <div>*/}
                                {/*            <i className={'bi bi-camera'} style={{fontSize:"40px"}}></i>*/}
                                {/*            <div><span style={{fontStyle:'italic'}}>Click here to add photo</span></div>*/}
                                {/*        </div> }*/}
                                {/*    </div>*/}
                                {/*</div> */}
                                <Card className={'mb-4 overflow-visible'}>
                                    <CardHeader title={`Personal Information`} subheader={`Names, Address, tel, ID`} titleTypographyProps={{ fontWeight: 'bold' }} />
                                    <CardContent>
                                        <Row>
                                            <Col md={4}>
                                                <RenderField name={'names'} label={"Full Names"} required={true} register={register} errors={errors} maxLength={50}/>
                                            </Col>
                                            <Col md={4}>
                                                <RenderField type={'email'} name={'email'} label={"Email Address"} placeholder={"Email"} required={true} register={register} errors={errors} />
                                            </Col>
                                            <Col md={4}>
                                                <RenderField size={'small'} type={'tel'} label={'Phone Number'} className={'form-control'} placeholder={'Tel'} name={'phone'} required={true} register={register} errors={errors} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={4}>
                                                <FormGroup className={'mb-3'}>
                                                    <FormLabel className={'w-100'}><Typography variant={'subtitle1'}>Country of Nationality <span className={'text-danger'}>*</span></Typography></FormLabel>
                                                    <Controller
                                                        control={control}
                                                        rules={{ required: "Nationality is required" }}
                                                        name={'nationality'}
                                                        render={({ field, fieldState: { error } }) => {
                                                            return (
                                                                <CountrySelector
                                                                    // className={errorClass2}
                                                                    value={field.value ?? null}
                                                                    options={fields}
                                                                    onChange={(v) => field.onChange(v?.value)}
                                                                />
                                                            )

                                                        }}
                                                    />
                                                    {renderError('nationality', errors)}
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <RenderField key={'country'} type={'number'} label={rwanda ? 'National ID' : 'Passport Number'} name={'nationalId'} required={true} register={register} errors={errors} minLength={rwanda ? 16 : undefined} maxLength={rwanda ? 16 :20} />
                                            </Col>
                                            <Col md={4}>
                                                <RenderField type={'file'} label={rwanda ? 'National ID' : 'Passport Copy'} className={'form-control'} placeholder={'NID'} name={'nidAttachment'} required={true} register={register} errors={errors} />
                                            </Col>
                                        </Row>
                                    </CardContent>
                                </Card>
                                <Card className={'mb-4'}>
                                    <CardHeader title={<span>Select preferred Job Position</span>} titleTypographyProps={{ fontWeight: 'bold' }}
                                        subheader={rwanda ? 'This position is exclusively available to local candidates (Rwandans) only.' : 'This position welcomes applications from both Rwandans and international candidates.'} />
                                    <CardContent>
                                        <Controller control={control} render={({ field, fieldState, formState, }) => {
                                            return <Row>
                                                {filteredPositions.map(v => <Col md={6} className={'mb-1'}>
                                                    <Checkbox onChange={(e) => {

                                                        const { value } = e.currentTarget;
                                                        let arr = field.value ? field.value : [];
                                                        if (inArray(arr, value)) {
                                                            arr = arr.filter(v => v !== value);
                                                        } else {
                                                            let array = [...arr, value];

                                                            if (v.requirements?.length > 0) {
                                                                setPosition({ ...v, array });
                                                            } else {
                                                                arr = array;
                                                            }
                                                        }
                                                        field.onChange(arr)

                                                    }} type={'checkbox'} checked={selectedPositions.includes(v.id)} id={v.id} value={v.id} name={'position'} />
                                                    <label htmlFor={v.id} className={'ms-2'}><Typography>{v.name}</Typography></label>
                                                    {v.requirements?.length > 0 && <a href="/requirements" className={'ms-2'} onClick={(e) => {
                                                        e.preventDefault();
                                                        setPosition(v);
                                                    }}><i className="bi bi-info-circle-fill"></i> Requirements</a>}
                                                </Col>)}
                                            </Row>;
                                        }} name={'position'} rules={{
                                            required: 'This field is required',
                                            validate: (v) => {

                                                if (v?.length > 2) {
                                                    return "You cannot select more than two positions";
                                                }

                                                return true;
                                            }
                                        }} />
                                        {renderError('position', errors)}
                                    </CardContent>
                                </Card>
                                <Card className={'mb-4 overflow-visible'}>
                                    <CardHeader title={`Academic Information`} titleTypographyProps={{ fontWeight: 'bold' }} subheader={`C.V, Education, Special skills , etc ..`} />
                                    <CardContent>
                                        <Row>
                                            <Col md={4}>
                                                <RenderField type={'select'} className={'form-control'} label={'Highest Level of Education'} placeholder={'Education'} name={'education'} required={true} values={[
                                                    { label: "-- select --", value: "" },
                                                    { label: "High School", value: "High School" },
                                                    { label: "Bachelor", value: "Bachelor" }, {
                                                        label: "Masters", value: "Masters",
                                                    },
                                                    { label: "PhD", value: "PhD", }
                                                ]} register={register} errors={errors} />
                                            </Col>
                                            {/* <Col md={4}>
                                                <RenderField type={'select'} className={'form-control text-capitalize'} label={'Institution Name'} placeholder={'School'} name={'school'} required={true} values={schools} register={register} errors={errors} />
                                            </Col> */}
                                            {addSchool ? <Col md={4}>
                                                <RenderField name={'otherSchool'} label={"Add Institution"} required={true} register={register} errors={errors} />
                                            </Col> : null}
                                            <Col md={4}>
                                                <FormGroup className={'mb-3'}>
                                                    <FormLabel className={'w-100'}><Typography variant={'subtitle1'}>Field of Study <span className={'text-danger'}>*</span></Typography></FormLabel>
                                                    <Controller
                                                        control={control}
                                                        rules={{ required: "Field of Study is required" }}
                                                        name={'studyField'}
                                                        render={({ field, fieldState: { error } }) => {
                                                            return (
                                                                <ReactSelect
                                                                    // className={errorClass2}
                                                                    value={field.value ? fields.find(v => v.value === field.value) : null}
                                                                    options={fields}
                                                                    onChange={(v) => field.onChange(v?.value)}
                                                                />
                                                            )

                                                        }}
                                                    />
                                                    {renderError('studyField', errors)}
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <RenderField label={'Curriculum vitae'} type={'file'} className={'form-control'} placeholder={'C.V'} name={'cv'} required={true} register={register} errors={errors} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <RenderField multiline={true} label={'Other special skills or technologies'} size={'small'} required={true} rows={3} className={'form-control'} name={'technology'} placeholder={'Type here ...'} register={register} errors={errors} maxLength={350}/>
                                            </Col>
                                            {/*<Col md={6}>*/}
                                            {/*    <FormGroup className={'mb-3'}>*/}
                                            {/*        <FormLabel>Summary of certifications. <span className={'text-danger'}>*</span></FormLabel>*/}
                                            {/*        <textarea required={true} rows={3} className={'form-control'} name={'certificates'} placeholder={'Add your certifications here'}/>*/}
                                            {/*    </FormGroup>*/}
                                            {/*</Col>*/}
                                        </Row>
                                        <div>
                                            <Button style={{ backgroundColor: "#054163" }} color={'secondary'} startIcon={<AttachFile />} onClick={toggle} variant={'contained'}>Attach Files (Degree, Certificates, Etc)</Button>
                                        </div>
                                        <div>
                                            {documents.length <= 0 ? <div className={'text-center p-3'}>
                                                <i className="bi bi-info-circle-fill" style={{ fontSize: '40px' }}></i>
                                                <div><Typography>No Documents added yet</Typography></div>
                                                <div className={'mt-2'} style={{ fontStyle: 'italic' }}><Typography>Upload academic and other professional certificates</Typography></div>
                                            </div> : <div className={'overflow-hidden'}>
                                                <table className={'table table-striped'}>
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            documents.map((v, index) => <tr>
                                                                <td>{v.name}</td>
                                                                <td><button className={'btn btn-sm btn-danger float-end'} onClick={() => {
                                                                    setDocuments(documents => {
                                                                        documents.splice(index, 1);
                                                                        return [...documents];
                                                                    })
                                                                }}><i className={'bi bi-trash'}></i></button></td>
                                                            </tr>)
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>}
                                        </div>
                                    </CardContent>
                                </Card>
                                <Card className={'mb-4'}>
                                    <CardHeader title={`Work Experience`} titleTypographyProps={{ fontWeight: 'bold' }} subheader={`Years, Current Employee`} />
                                    <CardContent>
                                        <Row>
                                            <Col md={6}>
                                                <RenderField label={'Current Employer'} type={'text'} className={'form-control'} name={'employer'} register={register} errors={errors} maxLength={150}
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <RenderField type={'number'} className={'form-control'} label={'Years of Experience'} placeholder={'Experience'} name={'experience'} register={register} errors={errors} />
                                            </Col>
                                        </Row>

                                    </CardContent>
                                </Card>

                                <Row className={'justify-content-end'}>
                                    <Col md={12}>
                                        <Alert severity={'warning'}>
                                            Only shortlisted candidates will be contacted for interview via the provided email and phone number
                                        </Alert>
                                        <div>
                                            <label htmlFor="accept">
                                                <Checkbox type={'checkbox'} id={'accept'} required={true} name={'accept'} {...register('accept', {
                                                    // required:'This is required',
                                                })} />
                                                <span>Accept Terms & Conditions to continue</span>
                                            </label>
                                            <p>{renderError('accept', errors)}</p>
                                        </div>
                                    </Col>
                                </Row>
                                <div className={'clearfix mt-3'}>
                                    <Button style={{ backgroundColor: "#054163" }} color={'secondary'} type={'submit'} startIcon={<Send />} variant={'contained'} disabled={loading} className={'float-end'}>
                                        Submit Application
                                    </Button>
                                </div>
                            </CardContent>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </form>
    </>;
}

export default connect(mapDispatchToProps)(ApplicationForm);
